export const host = getHost();
export const username = 'gsn';
export const password = 'GSN-L0g1n';
export const storageName = 'splitsecond2023sweeps';
export const entryPointValue = 'splitsecond2023sweeps';
export const apiUrl = '/api/v1/splitsecond2023sweeps';

export function debugAllowed() {

  const hostname = window.location.hostname;

  if (
    hostname.indexOf('localhost') === 0 ||
    hostname.indexOf('staging') === 0 ||
    hostname.indexOf('dev') === 0
  ) {
    return true;
  }

  return false;
}

export function getHost(cached = false) {
  const hostname = window.location.hostname;

  if (hostname.indexOf('localhost') !== -1 || hostname.indexOf('gsntv.test') !== -1) {
    return "";
  }

  if (hostname.indexOf('staging') !== -1) {
    return "https://staging.gsntv.com";
  }

  if (hostname.indexOf('dev') !== -1) {
    return "https://dev.gsntv.com";
  }

  if (cached) {
    return "https://www.gameshownetwork.com"; //cloudfront
  }

  return "https://origin-www.gameshownetwork.com";
}